import React, { useEffect, useState, lazy, Suspense } from "react";
import { useHistory } from 'react-router-dom';
import { SwiperSlide } from 'swiper/react/swiper-react.js';
import moment from "moment";

// @material-ui
import { Box, Typography, Button, Icon, Card, CardContent, Dialog, DialogTitle } from "@material-ui/core";
import { Alert } from '@material-ui/lab';
import Hidden from '@material-ui/core/Hidden';
import Link from '@material-ui/core/Link';
import Collapse from '@material-ui/core/Collapse';

// @sdk
import { AllysService, CourseService, HelpCenterService, LogsService, MembershipService, VoxyService, ProductService, MarketPlaceService, ProgramService } from "@sdk-point/talisis";

// @shared
import Loader from '../../../shared/components/Loader/LoaderContent';
import CoursesProvider, { useCoursesContext } from '../../../shared/components/CourseCarousel/context/CoursesProvider';
import TitleLink from '../../../shared/components/TitleLink/TitleLink';
import {goToCourseOfAlly, goToDetailCourse} from "../../../shared/utils/goToCourseOfAlly.js";
import { validateMembership } from "../../../shared/utils/membershipUtils";
import { convertSourceToImageResource } from "../../../constants/placeholderImages.js";
import { types } from '../../../shared/components/CourseCarousel/context/CoursesReducer';

import SlickCarousel from '../../../shared/components/SlickCarousel/SlickCarousel';
import AcademiesSection from "./AcademiesSection/AcademiesSection";
import NoCoursesFound from './components/NoCoursesFound';
import { convertOuToSource } from '../../../../src/constants/convertOuToSource';
import { getSessionCookie, setSessionCookie } from "../../../shared/utils/Sessions";
import { Mixpanel } from '../../../shared/components/Mixpanel/mixpanel';
import getConnectionAllies from '../../../shared/components/Allies/AlliesConnect';
import { SOURCES } from "../../../shared/constants/sources";
import { MEMBERSHIPS } from "../../../shared/constants/memberships";
import { log } from '../../../shared/utils/console.js'
import dateFormat from "../../../design-system/utils/dateFormat";
import { COMPLETE_DATE_FORMAT_SHORT } from "../../../design-system/constants/date-formats";
import DisabledCourseCard from "../../../design-system/components/Cards/DisabledCourseCard/DisabledCourseCard";
import cursosError from '../../../assets/images/cursosError.svg';
import { eventTracker } from "../../../shared/components/EventTracker/EventTracker.js";

// @styles
import useStyles from '../../../assets/styles/jss/pages/courses/coursesInProgressStyle';

// Cart
import { addProductsToCart } from "../../../shared/utils/cartHelper.js";
import { getNameMembership, getPeriodMembership } from "../../../shared/utils/checkoutHelpers.js";
import { manuallyAttemptMembershipPayment as attemptMembershipPayment } from "../../../shared/utils/membershipRepurchase.js";

// @Redux
import { applyCart, applyCartProducts } from "../../../redux/actions/cartActions.js";
import { setActiveTab, setActiveSubTab } from '../../../redux/actions/tabsActions';

// Roles
import { hasRole } from "../../../services/RoleService";
import { ROLE_ACADEMY, ROLE_ESTUDIANTE, ROLE_MAESTRO } from "../../../shared/constants/roles";
import { connect, useDispatch, useSelector } from "react-redux";
import { getLogoCard } from "../../../constants/logosImages";
import VoxyHHCard from "./VoxyHHCard";
import { CURSOS, CART, MEMBRESIAS } from "../../../routes/paths";
import BannerNotCourses from "./components/BannerNotCourses.jsx";

// Design-sytem
import StatusCourseCard from "../../../design-system/components/Cards/StatusCourseCard/StatusCourseCard.jsx";
import { getSourceBySourceAndCompany } from "../../../design-system/utils/source.js";
import { redirectMembershipView } from "../../../shared/utils/membershipUtils";

const CourseProgressCardBody = lazy(() => import('./components/CourseProgressCardBody'));
const CourseRenewMembershipCard = lazy(() => import('./components/CourseRenewMembershipCard'));

const AllysServiceSDK = new AllysService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);
const logsServiceSDK = new LogsService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);
const HelpCenterServiceSDK = new HelpCenterService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);
const courseService = new CourseService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);
const MembershipServiceSDK = new MembershipService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);
const VoxyServiceSDK = new VoxyService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);
const MarketPlaceServiceSDK = new MarketPlaceService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);
const ProgramServiceSDK = new ProgramService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);

const isAvailableCourseByDate = (localDate, courseDate) => courseDate.diff(localDate, 'seconds') < 1;
const isDisabledCourseByDate = (localDate, courseDate) => courseDate.diff(localDate, 'seconds') > 0;

const hasMembershipAccess = (programMembershipIds, userMembershipId) => {
    if (!programMembershipIds || !Array.isArray(programMembershipIds)) return true;
    if (!userMembershipId) return false;
    return programMembershipIds.includes(userMembershipId);
};

// prueba de cambio 

const CardsCoursesInProgress = (props) => {
    const history = useHistory();
    const classes = useStyles();
    const session = getSessionCookie();
    const { dispatch } = useCoursesContext();
    const dispatchCart = useDispatch();
    const [coursesEduconInProgress, setCoursesEduconInProgress] = useState({ courses: [] });
    const [courseAllysInProgress, setCoursesAllysInProgress] = useState({ courses: [] });
    const [programsInProgress, setProgramInProgress] = useState({ async_programs: [], sync_programs: [] });
    const [userMembership, setUserMembership] = React.useState(null);
    const [nextMembership, setNextMembership] = React.useState(null);
    const [userAddOn, setUserAddOn] = React.useState(null);
    const [voxyUserData, setVoxyUserData] = React.useState({});
    const [hhOnlineDialogOpen, setHHOnlineDialogOpen] = useState(false);
    const [redirectHHOnlineMessageError, setRedirectHHOnlineMessageError] = useState('');
    const [loading, setLoading] = useState(true);
    const [loadingHHOnline, setLoadingHHOnline] = useState(false);
    const [loadingRepurchase, setLoadingRepurchase] = useState(false);
    const CourseServiceSDK = new CourseService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);
    const ProductServiceSDK = new ProductService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);

    // NoCourses
    const [coursesSysError, setCoursesSysError] = React.useState(false);
    const [isRedirected, setIsRedirected] = React.useState(false)
    const [ticketSended, setTicketSended] = React.useState(false)
    const [allies, setAllies] = React.useState(null)
    const [open, setOpen] = React.useState(false);
    const [userHasCourses, setUserHasCourses] = React.useState(true);

    const [membershipRenovationCopyOpen, setMembershipRenovationCopyOpen] = React.useState(false);
    const [educonExpiredMap, setEduconExpiredMap] = React.useState({});

    const role = JSON.parse(localStorage.getItem('permissions'));
    const userRole = (role != null && role?.length > 0) ? JSON.stringify(role[0]?.role_name).replace(/["']/g, "") : 'Estudiante'; // Maestro

    const localDate = moment();
    const { user } = useSelector((state) => state.userReducer);
    const { cart } = useSelector((state) => state.cartReducer);

    const alliesFree = [
        SOURCES['GOOGLE'],
        SOURCES['HUBSPOT']
    ]

    const getOU = (email) => {
        let ouId;
        const domain = email.substring(email.lastIndexOf("@") + 1);
        switch (domain) {
            case 'red.unid.mx' || 'unid.mx':
                ouId = 'UNID'
                break;
            case 'u-erre.mx' || 'u-erre.edu.mx' || 'iesalud.edu.mx':
                ouId = 'UERRE'
                break;
            case 'talisis.com':
                ouId = 'TAL'
                break;
            default:
                break;
        }
        return ouId;
    }

    useEffect(() => {
        getAllData();
        setMembershipRenovationCopyOpen(true);
    }, []);

    useEffect(() => {
        const computeEduconExpired = async () => {
            const allCourses = coursesEduconInProgress.courses.flatMap(g => g.courses);
            if (allCourses.length === 0) return;
            const entries = await Promise.all(
                allCourses.map(async (c) => {
                    try {
                        const results = await MarketPlaceServiceSDK.getCourse(c.course_id);
                        const isExpired = results.price > 0 ? validateMembership(userMembership) : false;
                        return [c.course_id, isExpired];
                    } catch {
                        return [c.course_id, false];
                    }
                })
            );
            setEduconExpiredMap(Object.fromEntries(entries));
        };
        computeEduconExpired();
    }, [coursesEduconInProgress, userMembership]);

    const getAllData = async () => {
        setLoading(true);
        const personMembershipDetail = await MembershipServiceSDK.getPersonMembershipDetail(user.person_id);
        setUserMembership(personMembershipDetail.userMembership);
        setNextMembership(personMembershipDetail.nextMembership);
        const allyData = await getCoursesAllyInProgress();
        const educonData = await getCoursesEduconInProgress();
        const programData = await getProgramsInProgress();
        setProgramInProgress(() => programData);
        
        // Verifica si hay cursos reales: cursos de aliados, educación continua o programas sincrónicos
        const hasAllyCourses = allyData?.courses?.length > 0;
        const hasEduconCourses = educonData?.courses?.length > 0;
        const hasSyncPrograms = programData?.sync_programs?.length > 0;
        
        setUserHasCourses(hasAllyCourses || hasEduconCourses || hasSyncPrograms);
        
        setCoursesAllysInProgress(() => allyData);
        setCoursesEduconInProgress(() => educonData);
        setSessionCookie({...session, membership_id:personMembershipDetail?.userMembership?.id, membership_type_id: personMembershipDetail?.userMembership?.membership_type_id});
        setUserAddOn(personMembershipDetail.userAddOn);
        
        const voxyUserDataResponse = await VoxyServiceSDK.getExternalUserDataByIdTalisis(user.person_id);
        setVoxyUserData(voxyUserDataResponse);
        setLoading(false);
    };

    const getCoursesAllyInProgress = async () => {
        return await CourseServiceSDK.getCoursesAllyInProgressByUser(user.person_id);
    };

    const getCoursesEduconInProgress = async () => {
        const educonData = await CourseServiceSDK.getCoursesEduconInProgressByUser(user.person_id);

        return educonData;
    }
 
    const getProgramsInProgress = async () => {
        let response = { async_programs: [], sync_programs: [] };

        try {
            response = await ProgramServiceSDK.getProgramsByPersonId(user.person_id);
            dispatch({ type: types.ADD_PROGRAMS, payload: response.async_programs });
        } catch (error) {
            log('Error fetch programs by person id', error);
        }

        return response;
    };


    const handleChangePage = (e, type_resource, id, student) => {
        e.preventDefault();
        student = (type_resource === 'programas') ? `/${student}` : '';
        history.push(`/${type_resource}/${id}/cursos${student}`);
    };

    const handleCourseSysError = async (error) => {
        const eventdata = {
            userId: user.person_id,
            message: error.reason,
            unidadOperativa: user.ou
        }
        //falta migrar evento a SDK

        if (error.end) {
            setCoursesSysError(true)
        }
        log(error)
    }

    const getData = async () => {
        try {
            let coursesData = [];
            setLoading(true);

            const data = await courseService.getPersonCoursesInProgress(user.person_id);
            if (data?.response?.length > 0) {
                coursesData = data.response.slice();
            }
            else {
                setUserHasCourses(false)
            }
            setLoading(false);
            // handleSetChargeStatusForOptimize("progress"); //! Borrar si no falla nada
            return coursesData;
        }
        catch (e) {
            log(e.message);
        }
    };

    const getShortcutsAllies = async () => {
        try {
            var request = {
                person_id: user.person_id
            }
            const shortcuts = await AllysServiceSDK.getShortcutsAllies(request);

            let neoAllies = [];
            neoAllies = shortcuts.filter(ally => ally.company_id === 'UERRE' || ally.company_id === 'UNID');
            if (neoAllies.length === 0) {
                let error;
                error = {
                    reason: 'No encontramos relacion del alumno con cursos - no allies'
                }
                handleCourseSysError(error)
                const log = { "person_id": user.person_id, "errortype_id": 4, "errororigin_id": 1 }
                await logsServiceSDK.logError(log)
                log('validacion usuarios 1')
                let neoUser;
                try {
                    neoUser = await AllysServiceSDK.validateNeoUser({ studentid: user.email, ou: getOU(user.email) })
                } catch (error) {
                    log('Error al validar usuario', error);
                }
                if (!neoUser?.neo_id) {
                    error = {
                        reason: 'Alumno no encontrado en Neo',
                        end: true
                    }
                    handleCourseSysError(error)
                    const log = { "person_id": user.person_id, "errortype_id": 3, "errororigin_id": 1 }
                    await logsServiceSDK.logError(log)
                    setLoading(false)
                }
                else {
                    const ally = {
                        "source_id": 4,
                        "company_id": user.company_id,
                        "AllyName": "NEO"
                    };
                    log(ally)
                    await handleGoToAllyNeo(ally)
                    // setAllies(ally)
                    setLoading(false)
                    // setIsRedirected(true)
                    log('redirigido si 95')
                }

            }
            else {
                setLoading(false);
                if (neoAllies.length < 2) {
                    setIsRedirected(true)
                    log('redirigido si 103')
                    await handleGoToAllyNeo(neoAllies[0])
                }
                else {
                    setAllies(neoAllies);
                }
            }
        }
        catch (err) {
            setLoading(false);
            log('catch', err)
        }
    }

    const handleGoToNeo = async () => {
        setLoading(true);
        await getShortcutsAllies();
        setOpen(true);
    }

    const handleGoToAllyNeo = async (ally) => {
        setLoading(true)
        let neoUser;
        try {
            neoUser = await AllysServiceSDK.validateNeoUser({ studentid: user.email, ou: ally.company_id })
        } catch (error) {
            log('Error valited user', error);
        }
        if (neoUser?.neo_id) {
            log(neoUser)
            const neoCourses = await AllysServiceSDK.getNeoCoursesByUser({ studentid: neoUser.neo_id, ou: ally.company_id });
            log(neoCourses)
            if (neoCourses.length > 0) {
                const body = {
                    person_id: user.person_id,
                    email: user.email,
                    ou: getOU(user.email),
                    source_id: ally.source_id,
                    company_id: getOU(user.email),
                    course_id: null
                }
                const win = window.open(window.location.protocol + '//' + window.location.host + '/redireccionando/' + convertOuToSource(ally.company_id), "_blank");

                var urlRespuesta = await getConnectionAllies(body);
                log('respuesta allies', urlRespuesta)
                setTimeout(() => {
                    win.focus();
                    win.location.replace(urlRespuesta);
                }, 3000);
                setLoading(false)
                setIsRedirected(true)
            }
            else {
                log('No cursos en Neo')
                const error = {
                    reason: 'Sin Cursos en Neo',
                    end: true
                }
                setIsRedirected(false)
                log('redirigido NO')
                setOpen(true)
                handleCourseSysError(error)
                const log = { "person_id": user.person_id, "errortype_id": 1, "errororigin_id": 1 }
                await logsServiceSDK.logError(log)
                setLoading(false)
            }
        }
        else {
            const error = {
                reason: 'Alumno no encontrado en Neo',
                end: true
            }
            handleCourseSysError(error)
            const log = { "person_id": user.person_id, "errortype_id": 3, "errororigin_id": 1 }
            await logsServiceSDK.logError(log)
            setLoading(false)
        }
    }

    const handleClickHHOnline = async () => {
        setLoadingHHOnline(true);
        const responseVoxyAccessValidation = await VoxyServiceSDK.accessValidation({
            person_id: user.person_id,
            email_address: user.email,
            has_created_a_relationship: voxyUserData.has_created_a_relationship,
            external_user_id: voxyUserData.external_user_id
        });
        log(responseVoxyAccessValidation);
        if (responseVoxyAccessValidation.access) {
            const params = {
                person_id: user.person_id,
                ally: 'Voxy',
                source_id: SOURCES.VOXY,
                course_id: null,
                email: user.email
            }
            const window_ = window.open(window.location.protocol + '//' + window.location.host + '/redireccionando/' + convertOuToSource('HH'), "_blank");
            const urlRespuesta = await getConnectionAllies(params);
            log({ urlRespuesta });
            if (urlRespuesta.includes('https://retail.harmonhallonline.com.mx')) {
                setTimeout(() => {
                    window_.focus();
                    window_.location.replace(urlRespuesta ? urlRespuesta : window.location.protocol + '//' + window.location.host + CURSOS);
                }, 3000);
            }
            else {
                setHHOnlineDialogOpen(true);
                setRedirectHHOnlineMessageError(urlRespuesta);
            }
        }
        else {
            setHHOnlineDialogOpen(true);
            setRedirectHHOnlineMessageError(responseVoxyAccessValidation.message);
        }
        setLoadingHHOnline(false);
    };

    const handleCloseHHOnlineDialog = () => {
        setRedirectHHOnlineMessageError('');
        setHHOnlineDialogOpen(false);
    };

    const handleSendTicket = async () => {
        setLoading(true)
        log('Send ticket')
        const userReq = {
            user: {
                email: user.email,
                name: user.userName
            }
        }
        const zndeskUser = await HelpCenterServiceSDK.getZendeskUser(userReq).then(usr => usr);
        const ticketPayload = {
            ticketData: {
                zendeskId: zndeskUser.id,
                comment: 'No se muestran los cursos en progreso de NEO en la plataforma Talisis',
                subject: 'Error - No se muestran los cursos',
                custom_fields: [
                    {
                        id: "360048350694",
                        value: user.student_id ? user.student_id : ''
                    },
                    {
                        id: '8667463356439',
                        value: 'plataformas_clase'
                    },
                    {
                        id: '8529666934935',
                        value: 'neo'
                    }
                ],
                tags: [
                    "plataforma",
                    "web",
                    "talisis"
                ]
            }
        }
        const ticket = await HelpCenterServiceSDK.postTicket(ticketPayload).then(tckt => tckt)
        setLoading(false)
        log(ticket)
        setTicketSended(true)
    }

    const handleCloseMembershipRenovationMessage = () => {
        setMembershipRenovationCopyOpen(false);
    };

    const manuallyAttemptMembershipPayment = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        redirectMembershipView(e, dispatchCart, history)
        return;
        await attemptMembershipPayment({
            userMembership: nextMembership,
            userAddOn,
            cart,
            user,
            dispatchCart,
            applyCart,
            applyCartProducts,
            history,
            cartPath: CART,
            setLoadingRepurchase
        });
    };

    const noCoursesProps = {
        userHasCourses,
        handleGoToNeo,
        handleGoToAllyNeo,
        allies,
        coursesSysError,
        setCoursesSysError,
        handleSendTicket,
        open,
        setOpen,
        loading,
        ticketSended,
        isRedirected
    }

    const shouldShowBannerNotCourses = (!userHasCourses || userRole === "Maestro") && !loading && !voxyUserData?.has_created_a_relationship;
    // Si el userMembership.id está en algún membresia_id de los programas → renovacion
    // Si no está → upgrade
    const isRenovationMembership = [...programsInProgress.async_programs, ...programsInProgress.sync_programs]
        .some(program => Array.isArray(program.membresia_id) && program.membresia_id.includes(userMembership?.id));

    return (
        <React.Fragment> 
            {
                hasRole(ROLE_ACADEMY) &&
                <AcademiesSection 
                    user={user}
                    userMembershipId={userMembership?.id}
                    handleRenovationMembership={(e) => manuallyAttemptMembershipPayment(e)}
                    onClickUpgrade={() => history.push(MEMBRESIAS)}
                    merbershipIsExpired={validateMembership(userMembership)}/>

            }
            {!loading && (userMembership && userMembership.id > MEMBERSHIPS.FREEMIUM && (!userMembership.is_active || userMembership?.subscription_past_due)) &&
                <Collapse in={membershipRenovationCopyOpen}>
                    <Loader loading={loadingRepurchase} transparent={true} width="100%">
                        <Alert variant="filled" severity="info" color="info" icon={<i className="ri-error-warning-fill text-warning-400"></i>} className="mt-3">
                            <Typography component="div" variant="body2" className="semi-bold">Desafortunadamente no pudimos realizar el cobro para la {isRenovationMembership? 'renovación':'reactivar'} de tu membresía.</Typography>
                            <Box display="flex">
                                <Typography component="p" variant="body2" className="mt-2 text-warning-100" style={{ width: '90%' }}>
                                    Para renovar tu suscripción <Link href="" variant="body2" className="text-orange-300" onClick={manuallyAttemptMembershipPayment}>Haz clic aquí</Link>. Si ya realizaste tu pago <Link href="#" variant="body2" className="text-orange-300" onClick={() => {
                                        const talisisHelpDeskButton = document.getElementById('talisis_helpdesk_button');
                                        if (talisisHelpDeskButton) {
                                            talisisHelpDeskButton.click();
                                        }
                                    }}>Contáctanos</Link> para que nuestro equipo de soporte te ayude a {isRenovationMembership? 'renovación':'reactivar'} tu membresía.
                                </Typography>
                                <Typography component="p" align="right" style={{ width: '10%' }}>
                                    <Button className={classes.closeMembershipAlertButton} onClick={handleCloseMembershipRenovationMessage} endIcon={<i class="ri-close-line font-size-10"></i>}>CERRAR</Button>
                                </Typography>
                            </Box>
                        </Alert>
                    </Loader>
                </Collapse>
            }
            <CoursesProvider>
                <Loader loading={loading} transparent={true} minHeight="290px" width={!loading ? "100%" : "95%"} style={{ marginLeft: "auto", marginRight: "auto" }}>
                    {!loading && userRole !== "Maestro" && !userHasCourses && voxyUserData?.has_created_a_relationship && <VoxyHHCard classes={classes} onClick={handleClickHHOnline} mt={3} loading={loadingHHOnline} />}
                    {shouldShowBannerNotCourses && <BannerNotCourses />}
                    <Box className={classes.root}>
                        <Box position="relative">
                            {
                                coursesEduconInProgress.courses.map((courseEducon, index) => {
                                    return (<Box position="relative" className={[classes.hover_carousel, "mb-4"]} key={index}>
                                        <Typography className={classes.title} variant="h3">
                                            {(courseEducon.show_everything) ? <TitleLink textPrimary={courseEducon.name} className={classes.titlesin} textSecondary="Ver todos" onClick={(e) => handleChangePage(e, 'educon', courseEducon.id)} /> : courseEducon.name}
                                        </Typography>
                                        <SlickCarousel length={courseEducon.courses.length} typeCard="normal" slidestoshow={1} slidestoscroll={1} variablewidth='true' slidemargin="0px">
                                            {
                                                courseEducon.courses.map((courseItem, index) => {
                                                    return (<SwiperSlide key={courseItem?.course_id} className={classes.card}>
                                                        <Suspense fallback={<div></div>}>
                                                            <StatusCourseCard
                                                                courseId={courseItem.course_id}
                                                                sourceId={courseItem.source_id}
                                                                userId={parseInt(user.person_id ?? 0)}
                                                                sourceIdLogo={getSourceBySourceAndCompany(courseItem.source_id, courseItem.company_id)}
                                                                enrollmentStatusId={courseItem?.enrollment_status_id || 3}
                                                                media={{
                                                                    backgroundImage: courseItem?.image_url || convertSourceToImageResource( courseItem.company_id, courseItem.source_id),
                                                                    modalityId: courseItem?.modality_id || 2,
                                                                    percentage: courseItem?.progress_percentage,
                                                                }}
                                                                content={{
                                                                    courseName: courseItem?.name,
                                                                    grade: courseItem?.progress_percentage === 100 ? 100 : false,
                                                                }}
                                                                companyId={courseItem?.company_id}
                                                                onClickGoToCourse={() =>
                                                                    goToCourseOfAlly({
                                                                        person_id: user.person_id,
                                                                        email: user.email,
                                                                        ou: courseEducon.id,
                                                                        course_url: courseItem?.course_url,
                                                                        source_id: courseItem?.source_id,
                                                                        course_url_neo: courseItem?.courses_url_neo,
                                                                        course_id: courseItem?.course_id,
                                                                        company_id: courseItem?.company_id,
                                                                        course_name: courseItem?.title,
                                                                        setLoad: setLoading,
                                                                        eventSource: 'inEducon'
                                                                    })
                                                                }
                                                                isLogged={true}
                                                                approved={courseItem?.progress_percentage === 100 ? true : false}
                                                                showDetailButton={false}
                                                                handleRenovationMembership={(e) => manuallyAttemptMembershipPayment(e)}
                                                                merbershipIsExpired={
                                                                    educonExpiredMap[courseItem.course_id] || false
                                                                }
                                                            /> 
                                                        </Suspense>
                                                    </SwiperSlide>
                                                    )
                                                })
                                            }
                                        </SlickCarousel>
                                    </Box>
                                    )
                                })
                            }
                        </Box>
                        <Box position="relative">
                            {
                                courseAllysInProgress.courses.map(course => {
                                    return (<Box className={[classes.hover_carousel, "mb-4"]} key={course.id}>
                                        <Typography className={classes.title} variant="h3">
                                            {(course.show_everything) ? <TitleLink textPrimary={course.name} className={classes.titlesin} textSecondary="Ver todos" onClick={(e) => handleChangePage(e, 'aliados', course.id)} /> : course.name}
                                        </Typography>
                                        <SlickCarousel length={course.courses.length} typeCard="normal" slidestoshow={1} slidestoscroll={1} variablewidth='true' slidemargin="0px">
                                            {
                                                course.courses.map((courseItem, index) => {
                                                    return (<SwiperSlide key={courseItem?.course_id} className={classes.card}>
                                                        <Suspense fallback={<div></div>}>
                                                            <StatusCourseCard
                                                                courseId={courseItem.course_id}
                                                                sourceId={courseItem.source_id}
                                                                userId={parseInt(user.person_id ?? 0)}
                                                                sourceIdLogo={getSourceBySourceAndCompany(courseItem.source_id, courseItem.company_id)}
                                                                enrollmentStatusId={courseItem?.enrollment_status_id || 3}
                                                                media={{
                                                                    backgroundImage: courseItem?.image_url || convertSourceToImageResource( courseItem.company_id, courseItem.source_id),
                                                                    modalityId: courseItem?.modality_id || 2,
                                                                    percentage: courseItem?.lesson_percentage < 99 ? 71 : 100,
                                                                }}
                                                                content={{
                                                                    courseName: courseItem?.name,
                                                                    grade: 0,
                                                                }}
                                                                companyId={courseItem?.company_id}
                                                                onClickGoToCourse={() =>
                                                                    goToCourseOfAlly({
                                                                        person_id: user.person_id,
                                                                        email: user.email,
                                                                        ou: course.id,
                                                                        course_url: courseItem?.course_url,
                                                                        source_id: courseItem?.source_id,
                                                                        course_url_neo: courseItem?.courses_url_neo,
                                                                        course_id: courseItem?.course_id,
                                                                        company_id: courseItem?.company_id,
                                                                        course_name: courseItem?.title,
                                                                        setLoad: setLoading,
                                                                        eventSource: 'aliados'
                                                                    })
                                                                }
                                                                isLogged={true}
                                                                approved={false}
                                                                onClickGoToDetail={()=> 
                                                                    goToDetailCourse(courseItem?.course_id)(history)
                                                                }
                                                                showDetailButton={false}
                                                                handleRenovationMembership={(e) => manuallyAttemptMembershipPayment(e)}
                                                                merbershipIsExpired={
                                                                    alliesFree.includes(courseItem.source_id) ? false : validateMembership(userMembership)
                                                                }
                                                            />
                                                        </Suspense>
                                                    </SwiperSlide>
                                                    )
                                                })
                                            }
                                        </SlickCarousel>
                                    </Box>
                                    )
                                })
                            }
                        </Box>
                        {/* Voxy Harmon Hall online */}
                        {!loading && userRole !== "Maestro" && userHasCourses && voxyUserData?.has_created_a_relationship && <VoxyHHCard classes={classes} onClick={handleClickHHOnline} loading={loadingHHOnline} />}
                    </Box>
                </Loader>
                <Dialog open={hhOnlineDialogOpen} onClose={handleCloseHHOnlineDialog} className={classes.HH_online_dialog}>
                    <DialogTitle>
                        <Typography variant="h3">¡Ha ocurrido un error!</Typography>
                    </DialogTitle>
                    <Box className={classes.HH_online_dialog_message_error}>
                        <img loading="lazy" src={cursosError} className="HH_online_dialog_img_error"/>
                        <Typography variant="body2" color="textSecondary">{redirectHHOnlineMessageError}</Typography>
                    </Box>
                </Dialog>
            </CoursesProvider>
        </React.Fragment>
    )
}

const mapDispatchToProps = { setActiveTab, setActiveSubTab };

export default connect(null,mapDispatchToProps)(CardsCoursesInProgress);